/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthGetTokenResponse } from './AuthGetTokenResponse';

export type AuthGetTokenResponseApiRespoonse = {
    data?: AuthGetTokenResponse;
    status?: AuthGetTokenResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AuthGetTokenResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

